import "../assets/css/main.css";

interface registerCardInterface {
  title: string;
  details: string;
  activeDetails?: string;
  activeNumber?: number;
}

export const RegisterCard = ({
  title,
  details,
  activeDetails,
  activeNumber,
}: registerCardInterface) => {
  return (
    <div className="w-full rounded-2xl bg-white border border-slate-100 shadow-sm p-5 transition-all duration-300 hover:shadow-md hover:border-slate-200/80 group">
      <div className="flex items-center justify-between gap-4 mb-2">
        <h2 className="text-[15px] font-bold text-slate-800 tracking-tight capitalize group-hover:text-[#0096D1] transition-colors duration-200">
          {title}
        </h2>

        {activeDetails && activeNumber !== undefined && (
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-50 border border-slate-200 text-[11px] font-bold text-slate-500 tracking-wide">
            <span className="h-1.5 w-1.5 rounded-full bg-[#0096D1] animate-pulse" />
            <span className="opacity-80">{activeDetails}:</span>
            <span className="text-slate-800 font-extrabold">
              {activeNumber}
            </span>
          </div>
        )}
      </div>

      <p className="text-xs font-medium text-slate-400 leading-relaxed max-w-xl">
        {details}
      </p>
    </div>
  );
};
